{
  "AI_ASSISTANT": {
    "DOCK": {
      "LABEL": "Assistant",
      "SWITCH_MODE": "Switch dock mode",
      "SWITCH_TO": "Switch to",
      "MODE_FLOATING": "Floating",
      "MODE_SIDEBAR": "Sidebar",
      "MODE_FULLSCREEN": "Full screen"
    },
    "SHARED": {
      "STATUS": {
        "ACTIVE": "Active",
        "INACTIVE": "Inactive"
      },
      "COMING_SOON": "Coming soon",
      "BETA": "BETA",
      "SAVE": "Save",
      "EDIT": "Edit",
      "ADD": "Add",
      "CANCEL": "Cancel",
      "CONFIRM": "Confirm",
      "DELETE": "Delete",
      "CLOSE": "Close",
      "NEXT": "Next",
      "BACK": "Back",
      "LOAD_MORE": "Load more",
      "UPGRADE": "Upgrade to gain access",
      "MODIFIED": "Modified",
      "UNSAVED_CHANGES": {
        "TITLE": "Unsaved changes",
        "MESSAGE": "Are you sure you want to leave? You will lose any unsaved changes.",
        "CONFIRM": "Discard changes"
      },
      "DELETE_ASSISTANT_CONFIRMATION": {
        "TITLE": "Delete employee?",
        "MESSAGE": "Are you sure you want to delete this employee? This action cannot be undone. Custom capabilities will not be deleted, and will remain available for use on other employees.",
        "CONFIRM": "Delete",
        "CANCEL": "Cancel"
      },
      "DOWNLOAD_YAML": "Download YAML",
      "OK": "Ok",
      "CONFIGURE": "Configure",
      "ASSISTANT_TYPES": {
        "SYSTEM": "System",
        "INBOX": "Chat Receptionist",
        "SOCIAL_MARKETING": "Social AI",
        "VOICE_RECEPTIONIST": "Voice Receptionist",
        "CUSTOM": "Custom",
        "SALES_COACH": "Sales Coach",
        "REVIEW_MANAGER": "Review Manager",
        "MARKETER": "Marketer",
        "AI_SEARCH_SPECIALIST": "AI Search Specialist",
        "BLOGGER": "Blogger",
        "BUSINESS_APP": "Business App Assistant",
        "GENERATION": "Generation",
        "A2P": "A2P"
      }
    },
    "INFO_BANNER": {
      "WHATS_THIS": "What's this?"
    },
    "AUTONOMY_LABEL": "Autonomy:",
    "AUTONOMY_LEVELS": {
      "TITLE": "Levels of autonomy",
      "LEVEL_TITLE_FORMAT": "Level {{level}}: {{title}}",
      "AUTONOMY_SUGGESTIVE": {
        "LEVEL_NAME": "Suggestive",
        "TITLE": "Lightweight guidance, no action taken.",
        "DESCRIPTION": "Provides helpful suggestions or content recommendations, but never takes action on its own. Designed to support human decision-making, not replace it."
      },
      "AUTONOMY_ASSISTIVE": {
        "LEVEL_NAME": "Assistive",
        "TITLE": "On-demand support for single tasks.",
        "DESCRIPTION": "Helps complete straightforward actions, with just a click. Always initiated by a human."
      },
      "AUTONOMY_AUTONOMOUS": {
        "LEVEL_NAME": "Autonomous",
        "TITLE": "Handles routine workflows.",
        "DESCRIPTION": "Acts automatically when triggered, and can manage more advanced tasks with no human action needed."
      },
      "AUTONOMY_AGENTIC": {
        "LEVEL_NAME": "Agentic",
        "TITLE": "Fully autonomous agent.",
        "DESCRIPTION": "Plans and executes complex, multi-step workflows independently. Runs continuously or over time to achieve long-term outcomes without human involvement."
      }
    },
    "WORKFORCE": {
      "TITLE": "AI Workforce",
      "CREATE_ASSISTANT": "Create",
      "CONFIGURE_BUTTON": "Configure",
      "VIEW_BUTTON": "View",
      "CONFIGURE_ARIA_LABEL": "Configure {{name}}",
      "VIEW_ARIA_LABEL": "View {{name}} settings",
      "LIVE": "Live",
      "CHAT_BUTTON": "Chat",
      "TRY_IT": "Try it",
      "ERRORS": {
        "LOAD_FAILED": "Failed to load AI workforce. Please try again later.",
        "UPGRADE_UNAVAILABLE": "This upgrade isn't available right now. Please try again later."
      },
      "UPGRADE_CTA": "Upgrade",
      "CREATE_WITH_AI": "Create with AI",
      "RESPOND_WITH_AI": "Respond with AI",
      "WEBRTC": {
        "CALL": "Call",
        "CONNECTING": "Connecting...",
        "CONNECTED": "Connected",
        "MUTED": "Microphone muted",
        "CALL_ENDED": "Call ended",
        "END_CALL": "End call",
        "RETRY": "Retry",
        "TOGGLE_MICROPHONE": "Toggle microphone",
        "CAPACITY_ERROR": "Unable to start the call right now. Please try again in a moment."
      },
      "CHANNEL": {
        "ACTIVE": "active",
        "NOT_YET_ACTIVE": "not connected"
      },
      "DEFAULT_ASSISTANTS": {
        "CUSTOM_ASSISTANT": {
          "ERRORS": {
            "CREATE_FAILED": "Error creating custom employee"
          },
          "TITLE": "Custom employee",
          "DESCRIPTION": "A custom employee. Customize its personality, capabilities, and connected knowledge sources."
        },
        "AUTOMATED_ASSISTANT": {
          "TITLE": "Automated employee",
          "SUBTITLE": "Chat receptionist",
          "DESCRIPTION": "Provides a fast, helpful response to anyone messaging your business. Answers questions, promotes your products and services, and captures contact info for your team to follow up."
        },
        "CHAT_RECEPTIONIST": {
          "TITLE": "Chat receptionist",
          "SUBTITLE": "",
          "DESCRIPTION": "Provides a fast, helpful response to anyone messaging your business. Answers questions, promotes your products and services, and captures contact info for your team to follow up."
        },
        "VOICE_RECEPTIONIST": {
          "TITLE": "Voice receptionist",
          "SUBTITLE": "",
          "DESCRIPTION": "Answers calls to your business with a professional, friendly voice. Handles inquiries, promotes your products and services, and captures new leads—24/7.",
          "TRY_IT_TITLE": "Try the voice receptionist",
          "TRY_IT_INSTRUCTIONS": "Enable the voice receptionist and call your number, <strong>{{phoneNumber}}</strong>.",
          "ERRORS": {
            "PHONE_NUMBER": "Error fetching phone number",
            "ASSISTANT_CONNECTIONS": "Error fetching employee connections"
          },
          "STATUS": {
            "PROVISIONING": {
              "TITLE": "Provisioning",
              "MESSAGE": "Your voice receptionist is being provisioned and will be ready in a few minutes."
            },
            "INACTIVE": {
              "TITLE": "Inactive",
              "MESSAGE": "Your voice receptionist is inactive and will not answer calls."
            },
            "UNAVAILABLE": {
              "TITLE": "Unavailable",
              "MESSAGE": "Your voice receptionist is unavailable."
            }
          },
          "MINUTES_USED": "{{ used }}/{{ limit }} minutes used",
          "USAGE_PROGRESS": "{{ startDay }} to {{ endDay }}"
        },
        "CONTENT_CREATOR": {
          "TITLE": "Social Media Manager",
          "SUBTITLE": "",
          "DESCRIPTION": "Creates and publishes on-brand social media content to drive awareness, engagement, and leads. Drafts, schedules, and posts on your behalf, tailored to your goals and audience."
        },
        "BLOG_WRITER": {
          "TITLE": "Blogger",
          "SUBTITLE": "",
          "DESCRIPTION": "Creates SEO-friendly blogs tailored to your services, promotions, and customer search intent. Drafts, schedules, and publishes content that drives traffic and builds long-term trust."
        },
        "REVIEW_MANAGER": {
          "TITLE": "Review manager",
          "SUBTITLE": "",
          "DESCRIPTION": "Crafts a thoughtful response to reviews to manage your online reputation. Provides smart suggestions to get more positive reviews and handle negative ones."
        },
        "REPUTATION_SPECIALIST": {
          "TITLE": "Reputation Specialist",
          "SUBTITLE": "",
          "DESCRIPTION": "Crafts a thoughtful response to reviews to manage your online reputation. Provides smart suggestions to get more positive reviews and handle negative ones."
        },
        "SALES_COACH": {
          "TITLE_V2": "AI Sales Assistant",
          "SUBTITLE": "Coming soon",
          "DESCRIPTION": "Analyzes your recorded sales calls to highlight keywords and areas for improvement, helping you hone your skills and close deals more effectively."
        },
        "MARKETER": {
          "TITLE": "AI Marketer",
          "SUBTITLE": "",
          "DESCRIPTION": "Helps create and optimize marketing content for your business. Generates engaging copy, suggests campaign ideas, and assists with marketing strategies to grow your brand."
        },
        "SEARCH_EXPERT": {
          "TITLE": "AI Search Specialist",
          "SUBTITLE": "",
          "DESCRIPTION": "Monitors your business listings across directories to catch accuracy issues and track your listing health. Provides keyword ranking insights and audits how your brand appears in AI-powered search results."
        },
        "BUSINESS_APP_ASSISTANT": {
          "TITLE": "Business App Assistant",
          "SUBTITLE": "",
          "DESCRIPTION": "Helps users get the most out of the platform. Answers questions about features and workflows, points to the right settings, and guides users to complete tasks — grounded in the product documentation."
        }
      }
    },
    "CAPABILITIES": {
      "PAGE_TITLE": "Capabilities",
      "CREATE_CAPABILITY": "Create capability",
      "COLUMNS": {
        "NAME": "Capability name",
        "DESCRIPTION": "Description",
        "SCOPE": "Source",
        "PRODUCT": "Product",
        "ASSIGNED_ASSISTANTS": "Assigned Employees",
        "LAST_MODIFIED": "Last modified"
      },
      "SCOPE": {
        "GLOBAL": "Global",
        "SYSTEM": "System",
        "MANAGED": "Managed",
        "LOCAL": "Custom",
        "BUILT_IN": "Built in"
      },
      "ACTIONS": {
        "MENU": "Actions menu"
      },
      "DELETE": {
        "TITLE": "Delete Capability",
        "CONFIRMATION": "Are you sure you want to delete this capability and remove it from all employees? This action cannot be undone.",
        "SUCCESS": "Capability deleted successfully",
        "ERROR": "Failed to delete capability. Please try again."
      }
    },
    "GOALS": {
      "CONFIGURE_GOAL": {
        "TITLE": "Configure capability",
        "NAME": "Name",
        "DESCRIPTION": "Description",
        "TYPE": "Type",
        "SUPPORTED_CHANNELS": "Supported channels",
        "CHANNELS": {
          "ALL_CHANNELS": "All channels",
          "PLATFORM_CHAT": "Platform chat",
          "WEB_CHAT": "Web chat",
          "SMS": "SMS",
          "EMAIL": "Email",
          "VOICE": "Voice",
          "FACEBOOK": "Facebook",
          "INSTAGRAM": "Instagram",
          "WHATSAPP": "WhatsApp"
        },
        "PROMPT": "Prompt",
        "FUNCTIONS": "Tools",
        "FUNCTIONS_DESCRIPTION": "A list of tools which the AI employee can use as part of this capability.",
        "ADD_FUNCTION": "+ Add a tool",
        "SAVE_ERROR": "Error saving capability",
        "SAVE_SUCCESS": "Capability saved successfully",
        "FORM_INVALID": "Please fill out all required fields",
        "NAME_HELP_TEXT": "Enter a short, descriptive name for this capability configuration. This helps you identify it later.",
        "DESCRIPTION_HELP_TEXT": "This is for your reference only and won't be used by the AI.",
        "PROMPT_HELP_TEXT": "Define what you want the AI to do and how you want it to use the linked tools.",
        "PROMPT_VALIDATION_ERROR": "There is a syntax error in this prompt. Please check the formatting.",
        "PROMPT_TOOLTIP_TEXT": "This is a prompt section that is combined with other prompts of this AI employee. Clearly and concisely explain the steps you'd like your AI to take, and which tool(s) to use under which circumstances. Be careful your instructions do not conflict with other capabilities on the employee.",
        "PROMPT_PLACEHOLDER": "## Goal: When the user asks about... you can...\n- Step 1:  Ask the user...\n- Step 2: Then call [tool name] ...\n- Step 3: Then use the response from the tool to...",
        "CAPABILITY_INFO": {
          "TITLE": "What's a Capability?",
          "CONTENT": "<p>A <strong>capability</strong> is a way to organize your AI employee's instructions into clear, focused pieces. Instead of putting everything into one big prompt, you can separate out different parts of the AI employee's job—like providing information, asking for input, or responding to a request.</p>Each capability includes:<ul><li>A <strong>prompt</strong> that gives the AI employee instructions for what to say or do.</li><li>Optional <strong>tools</strong> the AI employee can use for fetching data or performing work.</li></ul>"
        }
      },
      "ADD_GOAL": {
        "ADD_A_CAPABILITY": "Add a capability",
        "NEW_CAPABILITY": "New capability",
        "ERROR_LOADING_CAPABILITIES": "Error loading capabilities",
        "ERROR_LOADING_CAPABILITY": "Error loading capability",
        "ERROR_SELECTING_CONFLICTING_CAPABILITIES": "Cannot select conflicting capabilities: {{capabilitiesNames}}"
      }
    },
    "FUNCTIONS": {
      "TOOL_INFO": {
        "TITLE": "What's a Tool?",
        "CONTENT": "<p>A <strong>tool</strong> lets your AI employee call an API. Most tools are used to get information that helps the AI employee give a better, more relevant response. Some tools may also send data or trigger actions. When creating a tool, make sure the capability’s prompt explains when the AI should use it and how to include the results in its response.</p>"
      },
      "ADD_FUNCTION": {
        "ADD_A_FUNCTION": "Add a tool",
        "NEW_FUNCTION": "New tool",
        "ERROR_LOADING_FUNCTIONS": "Error loading tools"
      },
      "CREATE_FUNCTION": {
        "RESPONSE_MASK": {
          "TITLE": "Response field mask",
          "TOOLTIP": "Restrict which fields of the tool's JSON response are sent to the AI. Only the fields you select are forwarded; everything else is dropped. Leave empty to send the full response.",
          "SAMPLE_LABEL": "Sample response",
          "SAMPLE_PLACEHOLDER": "Paste a sample JSON response from this tool to pick fields from",
          "SAMPLE_HINT": "Paste a real response so you can choose fields against its actual structure.",
          "INVALID_JSON": "That doesn't look like valid JSON.",
          "FIELDS": "Fields to send to the AI",
          "PREVIEW": "What the AI will see",
          "PREVIEW_PASSTHROUGH": "No fields selected — the full response is sent unchanged.",
          "SELECTED": "Selected:",
          "CLEAR": "Clear",
          "EMPTY": "No fields selected — the full response is sent to the AI.",
          "ORPHANS": "Saved fields not present in this sample (kept on save):"
        },
        "TITLE": "Create a tool",
        "NAME": "Name",
        "NAME_PATTERN_ERROR": "Name must be under 64 characters and can only include letters, numbers, underscores, or dashes.",
        "DESCRIPTION": "Description",
        "GENERATE_FROM_CURL": "Generate from cURL",
        "GENERATE": "Generate",
        "EXPORT_TO_CURL": "Copy as cURL",
        "METHOD": "Method",
        "URL": "URL",
        "URL_PLACEHOLDER": "https://api.example.com/api",
        "URL_ERROR": "Please enter a valid URL that begins with http:// or https:// (e.g., http://api.example.com/getData).",
        "URL_HINT": "Enter the full API endpoint, starting with http:// or https:// (e.g., https://api.example.com/getData).",
        "HEADERS": "Headers",
        "NO_HEADERS": "No headers added yet. Click \"Add header\" to add HTTP headers for this tool.",
        "HEADER_NAME_PLACEHOLDER": "Header name",
        "HEADER_VALUE_PLACEHOLDER": "Value",
        "ADD_HEADER": "+ Add header",
        "ADD_COMMON_HEADER": "Add common header",
        "PARAMETERS": "Parameters",
        "NO_PARAMETERS": "No parameters added yet. Click \"Add Parameter\" to add a parameter to this tool.",
        "ADD_PARAMETER": "+ Add parameter",
        "NO_API_CHECKBOX": "This tool does not call an API",
        "NO_API_HINT": "use this when you just want to format the AI's response",
        "CREATE": "Create",
        "NAME_HELP_TEXT": "Enter a short, unique name for this tool that matches what the tool will do.",
        "METHOD_TOOLTIP_TEXT": "Typically, you'll use GET for retrieving data, POST for creating new data, PUT/PATCH for updating existing data, and DELETE for removing data. However, make sure to use the method that your endpoint is expecting.",
        "DESCRIPTION_HELP_TEXT": "Give a brief description of what the tool does to help the AI understand how to use it.\n",
        "NO_OP_DESCRIPTION": "This function is a no-op and will not execute an API call.",
        "METHOD_HELP_TEXT": "The method your API endpoint expects.",
        "PARAMETERS_HELP_TEXT": "Parameters are additional pieces of information that help the API understand your request. These are typically added to the URL or request body to filter, sort, or provide extra details for the API to process.",
        "URL_HELP_TEXT": "Enter the full API endpoint, starting with http:// or https:// (e.g., https://api.example.com/users).",
        "HEADERS_HELP_TEXT": "API headers provide additional information to the server about the request or response. These should be the headers required by your API, such as authorization tokens, content types, or other custom metadata necessary for processing the request."
      },
      "SNACKBAR": {
        "SUCCESS_SAVING_TOOL": "Tool saved successfully",
        "ERROR_FETCHING_FUNCTION": "Error fetching function",
        "MISSING_FIELDS": "There are missing fields in the form",
        "SAVE_ERROR": "Error saving tool",
        "TOO_MANY_NESTED_PARAMETERS": "Too many nested object parameters"
      },
      "ERRORS": {
        "ID_REQUIRED": "Tool name is required",
        "ID_PATTERN": "Tool name must contain only letters, numbers, hyphens, and underscores (1-64 characters)",
        "DESCRIPTION_REQUIRED": "Tool description is required",
        "METHOD_REQUIRED": "HTTP method is required",
        "URL_REQUIRED": "URL is required",
        "URL_INVALID": "Please enter a valid HTTP or HTTPS URL",
        "HEADER_NAME_REQUIRED": "Header name is required",
        "HEADER_VALUE_REQUIRED": "Header value is required",
        "PARAMETER_NAME_REQUIRED": "Parameter name is required",
        "PARAMETER_TYPE_REQUIRED": "Parameter type is required",
        "PARAMETER_LOCATION_REQUIRED": "Parameter location is required"
      },
      "EDIT_FUNCTION": {
        "TITLE": "Edit tool",
        "DONE": "Done"
      },
      "PARAMETER": {
        "KEY_LABEL": "Parameter key",
        "KEY_PLACEHOLDER": "Enter the name of the parameter",
        "DESCRIPTION_LABEL": "Description",
        "DESCRIPTION_PLACEHOLDER": "Describe the purpose of this parameter so the AI can fill it dynamically",
        "TYPE_LABEL": "Type",
        "LOCATION_LABEL": "Location",
        "FIELDS": "Fields",
        "NO_FIELDS": "No {{name}} fields added yet. Click \"Add field\" to add a field.",
        "FIELD_NAME": "Field name",
        "FIELD_DESCRIPTION": "Field description",
        "ADD_FIELD": "+ Add field to: {{name}}",
        "ADD_FIELD_TO": "+ Add field",
        "ADD_ENUM_OPTION_TO": "+ Add enum option",
        "ADD_FIELD_NO_NAME": "+ Add field",
        "HELP_TEXT": {
          "NAME": "Enter the name of the parameter",
          "LOCATION": "Choose where this parameter goes in the request (e.g., body for POST data, query for URL params).",
          "TYPE": "Select the expected data type for this parameter. This helps ensure the correct format and guides how the AI will use it.",
          "DESCRIPTION": "Provide a description for the parameter that will help the AI employee understand how to fill it in dynamically before making the request"
        },
        "ARRAY_ITEMS": "Array item",
        "ARRAY_ITEM_DESCRIPTION": "Array item description",
        "REQUIRED": "Required",
        "CHOSEN_BY_AI": "Set by AI",
        "VALUE": "Value",
        "VALUE_PLACEHOLDER": "Enter the fixed value this parameter should be set to",
        "ENUM_OPTIONS": "Enum options",
        "ENUM_OPTION_VALUE": "enum option value",
        "TYPE": {
          "STRING": "String",
          "NUMBER": "Number",
          "BOOLEAN": "Boolean",
          "INTEGER": "Integer",
          "OBJECT": "Object",
          "ARRAY": "Array",
          "ENUM": "Enum"
        }
      },
      "AUTH_STRATEGY": {
        "LABEL": "Auth strategy",
        "NONE": "None",
        "CONNECTION_ID": {
          "LABEL": "Connection ID",
          "HINT": "Leave blank to resolve the connection from the selected integration at runtime. Enter a connection ID only to pin one specific connection."
        },
        "USE_CONNECTED_INTEGRATION": "This tool authenticates through a connected integration",
        "CONNECTED_INTEGRATION_REQUIRED": "Select an integration or enter a connection ID.",
        "INTEGRATION_REQUIRED": "Select an integration.",
        "INTEGRATION_TYPE": {
          "LABEL": "Integration",
          "HINT": "This tool authenticates with the selected integration. Make sure the URL field uses the correct base URL (the API domain or host, found in the integration's developer portal) and path. A connection for this integration must be set up on the Integrations page for it to work."
        },
        "VENDASTA_AUTH": "Vendasta Service Account Authentication",
        "IMPERSONATION": "Impersonation",
        "IMPERSONATION_WITH_PLATFORM_MANAGED_FALLBACK": "Impersonation with fallback to Vendasta Service Account Authentication",
        "CONNECTED_INTEGRATION": "Connected integration",
        "REQUIRED_SCOPES": "Required scopes",
        "LOADING_SCOPES": "Loading scope options..."
      }
    },
    "KNOWLEDGE_ACCESS": {
      "ASSOCIATED_PROFILE": "Associated profile",
      "MANAGE_PROFILE": "Manage profile",
      "NAME": "Name",
      "DESCRIPTION": "Description",
      "CONTENT": "Content",
      "CONTENT_HINT": "Provide frequently asked questions and answers or other text the AI can use in responses. This does not give special instructions to AI",
      "KNOWLEDGE_NAME": "Knowledge name",
      "URL": "URL",
      "MODE": "Mode",
      "LAST_REFRESHED": "Last refreshed:",
      "REFRESH": "Refresh",
      "REFRESHING_KNOWLEDGE": "Refreshing knowledge...",
      "MODE_SINGLE": "Single page",
      "MODE_RECURSIVE": "Follow links",
      "MODE_SITEMAP": "Sitemap",
      "KNOWLEDGE_ACCESS": "Knowledge access",
      "ADD_KNOWLEDGE": "Add knowledge",
      "ERROR_CREATING_KNOWLEDGE": "Error creating knowledge source.",
      "SUCCESS_CREATING_KNOWLEDGE": "Knowledge source created successfully.",
      "UNABLE_TO_SAVE": "There are some empty required fields.",
      "REFRESH_CONFIRMATION_TITLE": "Refresh this website?",
      "REFRESH_CONFIRMATION_MESSAGE": "This will update the content from the website. Pages found previously will be replaced.",
      "FINDING_PAGES": "Finding web pages...",
      "TRAINING": "Training queued...",
      "FEW_MINUTES": "This may take a few minutes",
      "WEB_PAGES": "Web pages",
      "TRAIN": "Train",
      "PICK_PAGES": "Pick pages to train the AI on:",
      "KNOWLEDGE_TYPES": {
        "TEXT": {
          "TITLE": "Text",
          "DESCRIPTION": "FAQs or custom info"
        },
        "WEBSITE": {
          "TITLE": "Website",
          "DESCRIPTION": "Retrieve info from a website",
          "UNABLE_TO_FIND": "No pages found at this URL. Please verify the address or try refreshing the content if you're certain it's correct."
        }
      }
    },
    "CONFIGURATION": {
      "VARIABLE_PLACEHOLDER": "Enter value for {{ variableName }}"
    },
    "SETTINGS": {
      "SETUP": "Setup",
      "SETUP_CONNECTIONS": "Setup {{ connectionName }}",
      "SETUP_TRIGGER": "Setup {{ triggerName }}",
      "SETTINGS": "Settings",
      "LOADING": "Loading employee...",
      "TITLE": "Configure",
      "SAVE_BEFORE_CALL": "Save your changes before testing the assistant",
      "CAPABILITY": "Capability",
      "TOOL": "Tool",
      "CREATE_CUSTOM_ASSISTANT_TITLE": "Create Custom Employee",
      "CREATE": "Create",
      "MODIFY": "Modify",
      "HISTORY": "History",
      "VERSION_HISTORY": {
        "TITLE": "Version history",
        "VERSION_NUMBER": "Version {{number}}",
        "VERSION_SHORT": "v{{number}}",
        "LIVE_WITH_VERSION": "Live · v{{number}}",
        "LIVE_WITH_UNPUBLISHED": "Live · unpublished changes",
        "NOT_PUBLISHED": "Not published",
        "LIVE_NOT_PUBLISHED": "Live · not published",
        "VERSION_WITH_UNPUBLISHED": "v{{number}} · unpublished changes",
        "CURRENT_BADGE": "Current",
        "NO_MESSAGE": "No version message",
        "LOAD_MORE": "Load more",
        "LOAD_MORE_ERROR": "We couldn't load more versions. Please try again.",
        "RETRY": "Try again",
        "ERROR_TITLE": "We couldn't load the version history",
        "EMPTY_TITLE": "No published versions yet",
        "EMPTY_DESCRIPTION": "Versions appear here after you publish a change to this employee.",
        "VIEWING_TITLE": "Viewing a previous version",
        "VIEWING_MESSAGE": "You're viewing this employee as it was on {{date}}. Triggers, knowledge, and automations aren't part of version history, so they aren't shown here.",
        "EDIT_FROM_VERSION": "Edit from this version",
        "BACK_TO_CURRENT": "Back to current",
        "LOAD_VERSION_ERROR": "We couldn't load that version.",
        "OVERWRITE_CONFIRM_TITLE": "Replace your unsaved changes?",
        "OVERWRITE_CONFIRM_MESSAGE": "Editing from this version replaces the changes you haven't saved yet.",
        "OVERWRITE_CONFIRM_CONFIRM": "Replace changes",
        "DISCARD_CONFIRM_TITLE": "Discard your unsaved changes?",
        "DISCARD_CONFIRM_MESSAGE": "Going back to the current configuration discards the changes you haven't saved yet.",
        "DISCARD_CONFIRM_CONFIRM": "Discard changes",
        "DRAFT": {
          "PUBLISH_ACTION": "Publish",
          "SAVE_ACTION": "Save changes",
          "ROW_TITLE": "Unpublished changes",
          "EDITING": "Unpublished changes",
          "EDITING_FROM_VERSION": "Unpublished changes from version {{number}}",
          "SAVED_INDICATOR": "Saved, not published",
          "SAVED": "Changes saved",
          "SAVE_ERROR": "We couldn't save your changes. Please try again.",
          "MATCHES_PUBLISHED": "These unpublished changes match the published version, so there's nothing to publish.",
          "LOAD_ERROR": "We couldn't load your unpublished changes.",
          "REPLACE_CONFIRM_TITLE": "Replace your unpublished changes?",
          "REPLACE_CONFIRM_MESSAGE": "This employee keeps one set of unpublished changes. Saving replaces what's there now, and it can't be recovered.",
          "REPLACE_CONFIRM_CONFIRM": "Replace changes",
          "LOAD_CONFIRM_TITLE": "Discard your unsaved changes?",
          "LOAD_CONFIRM_MESSAGE": "Opening your unpublished changes replaces the edits you haven't saved yet.",
          "LOAD_CONFIRM_CONFIRM": "Discard and open",
          "DISCARD_ACTION": "Discard changes",
          "DISCARD_CONFIRM_TITLE": "Discard these unpublished changes?",
          "DISCARD_CONFIRM_MESSAGE": "They're deleted and can't be recovered. The editor goes back to the published configuration, which doesn't change.",
          "DISCARD_CONFIRM_CONFIRM": "Discard changes",
          "DISCARDED": "Unpublished changes discarded",
          "DISCARD_ERROR": "We couldn't discard your changes. Please try again.",
          "DISCARD_PARTIAL": "Some of your changes couldn't be discarded. Try again to remove the rest.",
          "DISCARD_UNCONFIRMED": "Your changes were discarded, but we couldn't confirm it. Reload to check."
        }
      },
      "PUBLISH": {
        "TITLE": "Publish changes",
        "MESSAGE_LABEL": "Version message",
        "MESSAGE_HINT": "Describe what changed, so this version is recognisable in the history later.",
        "PUBLISH": "Publish"
      },
      "GENERATOR": {
        "PLACEHOLDER": "Describe the features you want to create or add to this AI employee",
        "TITLE": "AI Employee Builder",
        "HINTS": {
          "IMPROVE_PROMPTS": "Improve my prompts",
          "CREATE_CAPABILITY": "Create a new capability",
          "ADD_CATEGORY_CAPABILITIES": "Add useful capabilities for my business category"
        }
      },
      "AUTOMATION_GENERATOR": {
        "PLACEHOLDER": "Describe what you want this automation to do",
        "TITLE": "Automation Builder",
        "HINTS": {
          "START_FROM_SCRATCH": "Build an automation from scratch",
          "ADD_STEP": "Add a step to my automation",
          "IMPROVE": "Improve my existing automation"
        }
      },
      "GENERATION_CHAT": {
        "TRY_SAYING": "Try saying:",
        "HISTORY": {
          "TITLE": "Chat history",
          "NEW_CHAT": "New chat",
          "OPEN_HISTORY": "Show previous conversations",
          "CLOSE_HISTORY": "Close history",
          "EMPTY": "No previous conversations yet",
          "NO_PREVIEW": "No messages yet"
        }
      },
      "GENERATE_CONFIRM_TITLE": "Replace unsaved changes?",
      "GENERATE_CONFIRM_MESSAGE": "Applying a generated assistant will overwrite your in-progress edits. Continue?",
      "GENERATE_CONFIRM_CONFIRM": "Continue",
      "APPEARANCE": "Appearance",
      "PROFILE_CAPABILITY": {
        "TITLE": "Profile",
        "PURPOSE": {
          "TITLE": "Role",
          "HELP_TEXT": "Define your AI's role and behavioural guidelines.",
          "PROFILE_PROMPT_HINT": "This is a prompt section that is combined with other prompts of this AI employee. Any additional instructions not included in the capabilities below can be added here."
        },
        "MODEL": {
          "RECOMMENDED": "Recommended",
          "TITLE": "Generative AI",
          "HELP_TEXT": "Define the model that powers the AI's responses.",
          "SELECT": {
            "TITLE": "Written content generation model",
            "DEFAULT": "Use recommended",
            "DEFAULT_WITH_MODEL": "Use recommended ({{modelName}})"
          }
        },
        "SPEECH": {
          "TITLE": "Speech",
          "HELP_TEXT": "Define the model that powers speech and the sound of the AI's voice."
        },
        "COMBINED_PROMPT": {
          "TITLE": "Combined prompt",
          "HEADER": "Combined prompt for {{assistantName}}",
          "BUTTON": "View prompt",
          "TOOLTIP": "Copy prompt text to clipboard",
          "COPIED_TO_CLIPBOARD": "Prompt copied to clipboard",
          "FAILED_TO_COPY": "Failed to copy prompt to clipboard"
        }
      },
      "ROLLBACK": "Rollback to managed",
      "ROLLBACK_CAPABILITY_TITLE": "Rollback Capability",
      "ROLLBACK_CAPABILITY_CONFIRMATION": "Are you sure you want to rollback this capability to its managed version?",
      "ROLLBACK_CAPABILITY_ERROR": "Error rolling back capability",
      "APPEARANCE_DESCRIPTION": "How your AI's name and avatar appear in Web Chat and SMS",
      "GOALS_INSTRUCTIONS": "Goals and instructions",
      "KNOWLEDGE_SOURCES": "Knowledge",
      "KNOWLEDGE_SOURCES_DESCRIPTION": "Choose the information and knowledge collections the AI can pull from to improve its responses.",
      "AUTOMATIONS": "Automations",
      "AUTOMATIONS_DESCRIPTION": "The following automations send requests to this AI employee.",
      "JOBS_TO_BE_DONE": "Jobs to be done",
      "JOBS_TO_BE_DONE_DESCRIPTION": "How well your AI employee is doing the jobs it's expected to do, scored from real conversations.",
      "AUTOMATIONS_LAST_UPDATED": "Last updated: {{ updatedAt }}",
      "AUTOMATIONS_NO_AUTOMATIONS": "No automations found",
      "AUTOMATIONS_NO_AUTOMATIONS_DESCRIPTION": "Automations that use this AI employee must be turned on to appear here",
      "MANAGE_AUTOMATIONS": "Manage automations",
      "ERROR_LOADING_AUTOMATIONS": "Failed to load automations. Please try again later.",
      "LEARN_MORE": "Learn more",
      "SUMMARY_LANGUAGE": {
        "SET": "Conversation summaries are written in {{ language }}.",
        "UNSET": "Conversation summaries use your business location's language by default.",
        "CHANGE": "Change",
        "SET_LINK": "Set a language"
      },
      "SOMETHING_WENT_WRONG": "Something went wrong.",
      "ASSISTANT_UPDATED": "Employee updated successfully.",
      "ASSISTANT_CREATED": "Employee created successfully.",
      "ASSISTANT_DELETED": "Employee deleted successfully.",
      "ASSISTANT_UPDATE_INVALID": "Some of this employee's settings need fixing before it can be published.",
      "ASSISTANT_UPDATE_ERROR": "Error updating employee.",
      "ASSISTANT_UPDATE_RELOAD_REQUIRED": "Your changes were saved, but this page is now out of date. Reload before editing again.",
      "ASSISTANT_UPDATE_VERSION_CONFLICT": "This employee was published somewhere else while you were editing. Reload the page — any changes you saved are still there.",
      "ASSISTANT_UPDATE_PERMISSION_DENIED": "You don't have permission to edit this employee.",
      "ASSISTANT_DELETE_ERROR": "Error deleting employee.",
      "CAPABILITY_UPDATED": "Capability updated successfully.",
      "CAPABILITY_UPDATE_ERROR": "Error updating Capability.",
      "GLOBAL_CAPABILITY_READ_ONLY": "This is a global capability and cannot currently be edited here.",
      "GLOBAL_CAPABILITY_READ_ONLY_TITLE": "Global capability (read-only)",
      "GLOBAL_CAPABILITY_READ_ONLY_ENHANCED": "This is a global capability managed by the system and cannot be edited directly. To customize it for an employee, edit it from the Employee Configuration page where it will create a custom capability.",
      "LOCAL_OVERRIDE_TITLE": "Editing creates a custom capability",
      "LOCAL_OVERRIDE_EXPLANATION": "Changes you make here will create or update a custom capability. This capability can be assigned to other employees, and if it's already assigned to multiple employees, editing it will affect all of them. The original global capability will remain unchanged.",
      "CAPABILITY_NOT_FOUND": "Capability not found.",
      "ASSISTANT_NOT_FOUND": "Employee not found.",
      "ERROR_FETCHING_ASSISTANT": "Error fetching employee.",
      "ASSISTANT_VALIDATION_ERROR": "Please correct the invalid fields before saving.",
      "ASSISTANT_TITLE": "AI employee",
      "DEFAULT_ASSISTANT_NAME": "Chat Receptionist",
      "ASSISTANT_NAME": "Name",
      "ASSISTANT_NAME_TOOLTIP": "It's recommended you include a title after the name that clearly indicates to your users that they are interacting with an AI, and not a human employee, to set proper expectations.",
      "ROLE": "Role",
      "DESCRIPTION": "Description",
      "ASSISTANT_AVATAR": "Avatar",
      "ASSISTANT_PRIMARY_GOAL": "Primary goal",
      "CUSTOM_CAPABILITIES": "Custom capabilities",
      "CAPABILITIES": "Capabilities",
      "CAPABILITIES_DESCRIPTION": "Add instructions to shape the AI’s behavior and add tools to extend its abilities.",
      "ADD_CAPABILITY": "Add a capability",
      "MANAGE_CHANNELS": "Manage",
      "MANAGE_TRIGGERS": "Manage",
      "MOVE_UP": "Move up",
      "MOVE_DOWN": "Move down",
      "REMOVE": "Remove",
      "COPY_CAPABILITY": "Copy to clipboard",
      "COPY_CAPABILITY_TOOLTIP": "Copy capability configuration (prompt and tools) as JSON",
      "COPY_CAPABILITY_SUCCESS": "Capability copied to clipboard",
      "REMOVE_CAPABILITY_TITLE": "Remove Capability",
      "REMOVE_CAPABILITY_CONFIRMATION": "Are you sure you want to remove this capability?",
      "REMOVE_CAPABILITY_WITH_SITUATIONS_CONFIRMATION": "This capability is used in one or more situations. Removing it will modify or remove those situations.\n\nAre you sure you want to remove this capability?",
      "ASSISTANT_ADDITIONAL_INSTRUCTIONS": "Additional instructions",
      "ASSISTANT_ADDITIONAL_INSTRUCTIONS_DESCRIPTION": "Add any additional instructions for your AI employee to follow.",
      "ASSISTANT_ADDITIONAL_INSTRUCTIONS_LIMIT_EXCEEDED": "Too many characters",
      "VOICE_BETA_BANNER_MESSAGE": "Calls are limited to 10 minutes per call. Includes 300 minutes per month. Bonus: Enjoy extra minutes at no charge until mid-2026.",
      "CHANNELS": {
        "TITLE": "Channels",
        "SUBTITLE": "Choose which communication channels your AI employee is assigned to.",
        "FETCH_ERROR": "Error fetching channels.",
        "FETCH_WIDGET_NAME_WARNING": "Unable to load widget names.",
        "WEB_CHAT": "Web Chat",
        "SMS": "SMS",
        "NO_CHANNELS_AVAILABLE": "No channels available. Upgrade to gain access.",
        "EXISTING_CONNECTION": "This channel is currently assigned to another employee.",
        "EXISTING_CONNECTION_TOOLTIP": "Reassigning this channel will unassign it from other employees.",
        "VIEW_MORE": "View more",
        "VIEW_LESS": "View less"
      },
      "TRIGGERS": {
        "TITLE": "Triggers",
        "SUBTITLE": "Choose which events invoke your AI employee to act.",
        "FETCH_ERROR": "Error fetching triggers.",
        "TOGGLE_ON_SUCCESS": "Trigger successfully turned on.",
        "TOGGLE_OFF_SUCCESS": "Trigger successfully turned off.",
        "TOGGLE_ERROR": "Failed to update trigger. Please try again.",
        "NO_TRIGGERS_AVAILABLE": "No triggers available. Upgrade to gain access.",
        "EXISTING_TRIGGER": "This trigger is currently assigned to another employee.",
        "EXISTING_TRIGGER_TOOLTIP": "Reassigning this trigger will unassign it from other employees.",
        "PROFILE_OPTIMIZATION_CONSENT": "A complete, up-to-date business profile helps you perform better in search. Turn this on and your AI Search Specialist will automatically keep your profile search-ready, syncing updates across your listings so you show up accurately everywhere.",
        "SCHEDULED": {
          "NEXT_RUN": "{{ name }} will act next on {{ date }}"
        },
        "REVIEW_AGENT_BANNER": {
          "GOOGLE_NOT_CONNECTED": {
            "TITLE": "Connect Google to enable auto replies",
            "CONTENT": "To automatically respond to Google reviews, you need to connect your Google Business Profile."
          },
          "FACEBOOK_NOT_CONNECTED": {
            "TITLE": "Connect Facebook to enable auto replies",
            "CONTENT": "To automatically respond to Facebook reviews, you need to connect your Facebook account."
          },
          "GOOGLE_TOKEN_BROKEN": {
            "TITLE": "Reconnect Google to enable auto replies",
            "CONTENT": "Your Google Business Profile connection has expired. Reconnect Google to continue automatically responding to reviews."
          },
          "FACEBOOK_TOKEN_BROKEN": {
            "TITLE": "Reconnect Facebook to enable auto replies",
            "CONTENT": "Your Facebook connection has expired. Reconnect Facebook to continue automatically responding to reviews."
          },
          "BOTH_SOURCES_NOT_CONNECTED": {
            "TITLE": "Connect review sources to enable auto replies",
            "CONTENT": "To automatically respond to reviews, connect at least one review source. Connect your Google Business Profile or Facebook to continue."
          },
          "BOTH_SOURCES_TOKEN_BROKEN": {
            "TITLE": "Reconnect review sources to enable auto replies",
            "CONTENT": "Your review source connections have expired. Reconnect at least one source Google Business Profile or Facebook to continue using auto replies."
          },
          "MIXED_SOURCE_CONNECTIONS_ISSUE": {
            "TITLE": "Connect a review source to enable auto replies",
            "CONTENT": "To automatically respond to reviews, you need at least one active review source. Connect or reconnect your Google Business Profile or Facebook to continue."
          }
        }
      },
      "SYSTEM_ASSISTANT": {
        "DESCRIPTION": "In-platform AI assistant",
        "ALERT_INFORMATION": "{{assistantName}} is the AI that appears in the top navigation of Partner Center that all partners can chat with privately."
      },
      "ENABLE_LEAD_CAPTURE": {
        "DESCRIPTION": "Capture lead information",
        "INFORMATION": "The AI will prioritize getting a name and contact information, create a new contact, and let the user know someone on your team will follow up."
      },
      "LEAD_CAPTURE": {
        "SELECT_FIELDS": "Fields to capture from conversations",
        "ADD_FIELD_PLACEHOLDER": "Add custom field...",
        "FIELDS_HINT": "The AI automatically saves these details when it detects them in a conversation.",
        "VOICE_INFO": "The assistant captures First name, Last name, Phone, Email, Marketing Email Consent, and SMS Consent into your CRM whenever the caller provides them. To change how it asks (one question vs. several at once, skip a field, accept hedged answers), edit the assistant's prompt."
      },
      "EMPTY_STATE": {
        "NO_TRIGGERS": "No triggers yet.",
        "NO_CAPABILITIES": "No capabilities yet.",
        "NO_AUTOMATIONS": "No automations yet."
      },
      "INTEGRATIONS": {
        "LABEL": "{{displayName}} integration",
        "CONNECT": "Connect {{displayName}}",
        "MANAGE": "Manage {{displayName}}",
        "SELECT_PLACEHOLDER": "Select a connection",
        "SELECT_REQUIRED_ERROR": "Select a connection to use for this capability."
      },
      "TRANSFER_CALL": {
        "PHONE_NUMBER": {
          "LABEL": "Phone number",
          "PLACEHOLDER": "Number to transfer to"
        },
        "CRITERIA": {
          "LABEL": "Criteria",
          "PLACEHOLDER": "When to transfer to this number"
        },
        "ADD_NUMBER": "Add a transfer number",
        "TRANSFER_ERRORS": {
          "PHONE_NUMBER_REQUIRED": "Phone number is required",
          "PHONE_NUMBER_INVALID": "Please enter a valid phone number",
          "CRITERIA_REQUIRED": "Criteria is required"
        }
      },
      "ONCALL_DISPATCH": {
        "PHONE_NUMBER": {
          "LABEL": "Phone number",
          "PLACEHOLDER": "On-call number to reach"
        },
        "CRITERIA": {
          "LABEL": "Criteria",
          "PLACEHOLDER": "When to dispatch to this number"
        },
        "ADD_NUMBER": "Add an on-call number",
        "ANNOUNCEMENT": {
          "LABEL": "Announcement",
          "PLACEHOLDER": "What the assistant tells the technician (optional)",
          "HINT": "Spoken to whichever technician answers. Leave blank to use the default announcement."
        },
        "ONCALL_ERRORS": {
          "PHONE_NUMBER_REQUIRED": "Phone number is required",
          "PHONE_NUMBER_INVALID": "Please enter a valid phone number",
          "CRITERIA_REQUIRED": "Criteria is required"
        }
      },
      "CRM_UPDATE": {
        "CONTACT_FIELDS_LABEL": "Contact fields to update",
        "COMPANY_FIELDS_LABEL": "Company fields to update",
        "OPPORTUNITY_FIELDS_LABEL": "Opportunity fields to update",
        "CUSTOM_OBJECT_FIELDS_LABEL": "{{name}} fields to update",
        "ADD_CONTACT_FIELD": "Add contact field...",
        "ADD_COMPANY_FIELD": "Add company field...",
        "ADD_OPPORTUNITY_FIELD": "Add opportunity field...",
        "ADD_CUSTOM_OBJECT_FIELD": "Add {{name}} field...",
        "SEARCH_FIELDS": "Search fields...",
        "NO_FIELDS_FOUND": "No matching fields",
        "OVERWRITE_IF_EMPTY": "Overwrite if empty",
        "OVERWRITE_ALWAYS": "Always overwrite",
        "NO_FIELDS_SELECTED_DEFAULT": "No fields selected. Default {{objectType}} fields will be used for the capability",
        "NO_FIELDS_SELECTED_REQUIRED": "No fields selected. This {{objectType}} won't be included in the capability.",
        "CONTACT": "contact",
        "COMPANY": "company",
        "OPPORTUNITY": "opportunity"
      },
      "CONTEXTUAL_PARAMETERS": {
        "AUTO": "Auto",
        "AUTO_FETCHED": "Auto-fetched from context",
        "TOOLTIP": "Value is automatically retrieved from the active AI conversation context."
      },
      "IMAGE_GENERATION": {
        "MODEL_LABEL": "Image generation model"
      },
      "ENABLE_MEETING_BOOKING": {
        "LABEL": "Select event link to book with:",
        "DESCRIPTION": "Book calendar events",
        "INFORMATION": "When selected, users will be guided through booking a calendar event during the conversation. We'll collect their preferred time and show real-time availability.",
        "MANAGE_EVENT_LINKS": "Manage event links",
        "PERSONAL": "Personal",
        "TEAM": "Team",
        "SERVICE": "Service menus",
        "VOICE_HINT": "Only events and service menus with a mandatory phone number field and SMS notifications appear here.",
        "VOICE_HINT_PARTNER": "All events and service menus appear here. Guests receive booking confirmations and reminders by email.",
        "VOICE_NO_EVENTS": "- No events listed that require a phone number or SMS notifications -",
        "SELECT_PLACEHOLDER": "Select event(s) from the list.",
        "QUESTION_1": "When \"Capture lead information\" is also enabled:",
        "ANSWER_1": "The employee will first collect the user's name, email, and optionally their phone number before scheduling. This ensures lead information is saved even if the user abandons the process.",
        "QUESTION_2": "When \"Capture lead information\" is disabled:",
        "ANSWER_2": "The employee will only gather the essential details needed for booking—typically name and email.",
        "QUESTION_3": "Will it ask for a phone number twice?",
        "ANSWER_3": "No, the employee intelligently avoids redundancy. If a phone number is gathered during lead capture and is also needed for booking, it will reuse the same information.",
        "UPGRADE_BADGE": "Upgrade available",
        "UPGRADE_TOOLTIP": "This capability has been upgraded. Use Book multiple appointments - Chat (email + phone) or Book multi appointments - Voice (phone only) for the latest features and multi-service booking. This capability will soon be deprecated."
      },
      "IMAGE_UPLOAD": {
        "CHANGE_APPEARANCE": "Change your AI employee's appearance",
        "REMOVE_IMAGE": "Remove image",
        "HINT": "Pick an employee profile picture.",
        "CHANGE": "Change",
        "REMOVE": "Remove"
      },
      "IMAGE_LIBRARY": {
        "TITLE": "Choose an image",
        "DESCRIPTION": "This image will be used as your AI employee’s avatar in the app and on your public web chat.",
        "SELECT_ERROR": "Failed to select image"
      },
      "ENABLE_LEAD_CAPTURE_DIALOG": {
        "INFORMATION_HEADING": "What does lead capture do?",
        "INFORMATION": "Lead capture automatically collects contact information from potential customers who chat with your AI employee, ensuring your business never misses a chance to follow up and turn conversations into customers. When a visitor mentions their first name, last name, phone number, email address, SMS consent, or marketing email consent, the AI captures those details and creates a new contact in your CRM. You can also add extra fields based on your business needs and prompt your AI employee to ask for them during conversations, allowing it to act as a 24/7 lead qualifier that gathers the right details to help your team close more deals.",
        "INFORMATION_2_HEADING": "How it works",
        "INFORMATION_2": "When a visitor shares their contact information, the AI automatically stores all available details in your CRM. After a short delay, your team receives a lead notification with a summary of the conversation, ensuring the full chat is captured before the alert is sent. This makes it easy to review the interaction and follow up while the lead is still engaged.",
        "INFORMATION_3_HEADING": "If lead capture is disabled",
        "INFORMATION_3": "If you disable this option, the AI employee will act as a help agent, answering questions but not asking for contact details or telling visitors that someone will follow up. Leads from these chats will not be captured in your CRM.",
        "INFORMATION_4": "If you remove this capability, the AI employee will act as a help agent, answering questions but not asking for contact details or telling visitors that someone will follow up. Leads from these chats will not be captured in your CRM."
      },
      "ADDITIONAL_INSTRUCTIONS_DIALOG": {
        "TITLE": "Additional instructions information",
        "INFORMATION_WARNING": "Warning:",
        "INFORMATION": "These instructions will affect the main instructions and conversational behavior of your AI employee. Make sure to test your employee thoroughly after making any changes, because this has the potential for unintended consequences for your AI employee's behavior. Use plain text or markdown format.",
        "EXAMPLE_HEADING": "Example instructions that you can use:",
        "EXAMPLE_1": "Link sharing: Describe when the AI employee should direct someone to a link, like if they want to book a meeting or create a support ticket.",
        "EXAMPLE_2": "Ask additional qualifying questions, like if the user is within service area, or more details about their project.",
        "EXAMPLE_3": "Adjust the employee's tone and personality to match your brand voice.",
        "EXAMPLE_4": "Localizations – for example, you could ask it to use British English instead of American English.",
        "EXAMPLE_5": "Adjust the conversation flow, like ask for both the phone number and email address, or ask for the email address first.",
        "EXAMPLE_6": "Ask for additional contact fields; these fields will be added to the contact if found within the conversation:",
        "FIELD_1": "First name",
        "FIELD_2": "Last name",
        "FIELD_3": "Phone number",
        "FIELD_4": "Email address",
        "FIELD_5": "Address",
        "FIELD_6": "City",
        "FIELD_7": "State/Province",
        "FIELD_8": "Zip/Postal code",
        "FIELD_9": "Country",
        "DO_NOT_WORK_HEADING": "Instructions that do not work yet:",
        "DO_NOT_WORK_DESCRIPTION": "You cannot make the AI employee perform actions outside of the conversation. For example, you cannot say \"If a customer asks for [employee], then notify that user.\""
      },
      "BUSINESS_PROFILE": {
        "BUSINESS_PROFILE": "Business Profile",
        "ALLOW_ACCESS": "Allow access to your business profile",
        "DESCRIPTION": "Answer questions about your business contact information, hours, products and services you offer.",
        "MANAGE_BUSINESS_PROFILE": "Manage business profile",
        "LEARN_MORE": {
          "TITLE": "Learn more",
          "WHAT_INFORMATION_QUESTION": "What information is made available to your AI employee?",
          "WHAT_INFORMATION": "These fields are shared from your business profile:",
          "BUSINESS_NAME": "Business name",
          "ADDRESS_SERVICE_AREAS": "Address and/or service areas",
          "WEBSITE": "Website",
          "PHONE_NUMBER": "Phone number",
          "CATEGORIES": "Categories",
          "HOURS": "Hours",
          "SERVICES_OFFERED": "Services offered",
          "SHORT_DESCRIPTION": "Short description",
          "LONG_DESCRIPTION": "Long description",
          "SOCIAL_MEDIA_URLS": "Social media URLs",
          "BOOKING_URL": "Booking URL"
        }
      },
      "VOICE_CONFIG": {
        "VOICE_CONFIG": "Voice Configuration",
        "FAMILY": "Provider",
        "FAMILY_DESCRIPTION": {
          "ASTRA": "Multilingual, less expressive, slower speaking",
          "HORIZON": "Multilingual, very expressive",
          "ECHOES": "English-only, less expressive, slower response times",
          "GPT_RT_PREVIEW_SEPT_2024": "Multilingual, less expressive, slower speaking",
          "GPT_RT_PREVIEW_DEC_2024": "Multilingual, very expressive",
          "GPT_RT_PREVIEW_JUN_2025": "Multilingual, very expressive",
          "GPT_RT_AUG_2025": "Multilingual, very expressive",
          "OPENAI_TTS": "Multilingual, very expressive",
          "DEEPGRAM_AURA": "English-only, more accurate, less expressive, slower response times",
          "DEEPGRAM_AURA_2": "Multilingual (EN, ES, IT, FR, DE, JA, NL), expressive, fast response times",
          "ELEVEN_LABS_FLASH_2_5": "Multilingual, expressive, fast response times"
        },
        "VOICE": "Voice",
        "LANGUAGE": "Language",
        "ALL": "All",
        "TABLE": {
          "NAME": "Voice",
          "GENDER": "Gender",
          "ACCENT": "Accent"
        },
        "GENDER": {
          "MALE": "Male",
          "FEMALE": "Female",
          "MASCULINE": "Masculine",
          "FEMININE": "Feminine"
        },
        "REGION": {
          "US": "American",
          "UK": "British",
          "IRELAND": "Irish",
          "PHILIPPINES": "Filipino",
          "AUSTRALIA": "Australian",
          "SWEDEN": "Swedish",
          "ITALY": "Italian",
          "CANADA": "Canadian",
          "SPAIN": "Spanish",
          "COLOMBIA": "Colombian",
          "FRANCE": "French",
          "GERMANY": "German",
          "JAPAN": "Japanese",
          "NETHERLANDS": "Dutch"
        },
        "RECOMMENDED": "Recommended",
        "PRE_GREETING_MESSAGE": {
          "LABEL": "Play pre-greeting message",
          "DESCRIPTION": "A message that will be played before the AI greets the caller. This can be used to provide a compliance message or other pre-conversion information."
        },
        "CUSTOM_VOICE": {
          "LABEL": "Custom voice ID",
          "PLACEHOLDER": "Enter ElevenLabs voice ID",
          "DESCRIPTION": "Enter the ID of any voice in ElevenLabs' public library.",
          "USE_CUSTOM": "Use a custom voice ID",
          "USE_LIBRARY": "Use a voice from the library",
          "NOT_FOUND": "Voice not found. Please check the voice ID and try again.",
          "SURCHARGE": "This voice requires an additional charge and cannot be used."
        },
        "ADVANCED": "Advanced voice options",
        "TURN_DETECTION": {
          "VAD_TYPE": {
            "LABEL": "Voice activity detection type",
            "DESCRIPTION": "Voice Activity Detection (VAD) controls how the AI detects when the caller is speaking and avoids interrupting them.",
            "SEMANTIC_VAD": "Semantic VAD",
            "SEMANTIC_VAD_HINT": "Uses AI to understand speech patterns and natural pauses for more accurate turn-taking.",
            "SERVER_VAD": "Simple VAD",
            "SERVER_VAD_HINT": "Uses audio volume thresholds to detect when someone is speaking."
          },
          "EAGERNESS": {
            "LABEL": "Response eagerness",
            "DESCRIPTION": "Controls how quickly the AI responds after detecting the caller has stopped speaking. Lower values wait longer before responding.",
            "LOW": "Low",
            "MEDIUM": "Medium",
            "HIGH": "High"
          },
          "THRESHOLD": {
            "LABEL": "Interruption threshold",
            "DESCRIPTION": "This threshold helps the AI tell the difference between background noise and a human speaking, with a higher value meaning the AI is less likely to be interrupted. Recommended range is 0.60 to 0.75"
          },
          "PREFIX_PADDING": {
            "LABEL": "Prefix padding",
            "DESCRIPTION": "Specifies the amount of audio (in milliseconds) to include before the detected start of speech. This ensures that the beginning of the speech isn't cut off."
          },
          "SILENCE_DURATION": {
            "LABEL": "Silence duration",
            "DESCRIPTION": "Determines the length of silence (in milliseconds) that indicates the end of speech. Adjusting this helps in managing how quickly the AI responds after a user stops speaking."
          }
        }
      },
      "CUSTOM_KNOWLEDGE": {
        "AI_KNOWLEDGE_BASE": "AI knowledge base",
        "MANAGE_KNOWLEDGE": "Manage knowledge",
        "MANAGE_KNOWLEDGE_DESCRIPTION": "Create and manage facts and information that can be added to AI employees",
        "REFRESH_OPTIONS": "Refresh options",
        "ADD_KNOWLEDGE": "Add knowledge",
        "NEW_KNOWLEDGE": "New knowledge",
        "SELECT_KNOWLEDGE": "Select knowledge",
        "CUSTOM_KNOWLEDGE": "Q&A",
        "DESCRIPTION": "Provide additional facts and answers to frequently asked questions your Chat Receptionist can use when responding to inquiries.",
        "MAX_CHARACTER_EXCEEDED": "Maximum character limit exceeded",
        "APPLICATION_SETTINGS": "Settings",
        "APPS_WARNING": "This knowledge is currently being used by the following:",
        "NO_APPS": "This knowledge is not currently being used.",
        "EDIT": {
          "TITLE": "Custom knowledge",
          "NAME": "Name",
          "CONTENT": "Content"
        },
        "DELETE": {
          "TITLE": "Delete custom knowledge?"
        }
      },
      "CONNECTIONS": {
        "RESPOND_TO": "Respond to {{ connectionName }}",
        "MESSAGE_RECEIVED": "Message received on {{ connectionName }}",
        "MESSAGE_RECEIVED_WEBCHAT": "Message received on Web Chat {{ connectionName }}",
        "VOICE_ACTION_LABEL": "Answers phone calls",
        "TRY_MY_LISTING": "Enable and Try",
        "AUTO_REVIEW_RESPONSE": "New review received",
        "EMAIL_RECEIVED": "Email received",
        "EMAIL_RECEIVED_TO": "Email received to {{ emailAddress }}",
        "PERSONAL_EMAIL_RECEIVED": "Personal email mailbox (Gmail/Outlook)",
        "PERSONAL_EMAIL_RECEIVED_TO": "Personal email mailbox: {{ emailAddress }}"
      },
      "SALES_COACH": {
        "SALES_METHODOLOGY": {
          "TITLE": "Sales methodology",
          "MEDDPICC": "MEDDPICC",
          "BANT": "BANT",
          "SANDLER": "Sandler Selling System"
        },
        "SUMMARIZE_AND_SCORE": "Summarize and score meetings",
        "RAVEN": {
          "TITLE": "Meetings are evaluated based on the RAVEN framework:",
          "R": "<b>R</b> - Rapport and context",
          "A": "<b>A</b> - Assessment and discovery",
          "V": "<b>V</b> - Value delivery",
          "E": "<b>E</b> - Engagement and objection handling",
          "N": "<b>N</b> - Next steps and ownership"
        },
        "DISPLAY_NAME_LABEL": "Meeting display name",
        "DISPLAY_NAME_DESCRIPTION_V2": "The meeting notetaker will use this name when joining meetings",
        "LOG_CRM_ACTIVITY": "Log meeting activity in the CRM",
        "LOG_CRM_ACTIVITY_DESCRIPTION": "The activity will be associated to the contacts invited to the meeting. The activity will provide a link to view the meeting details including the recording and transcription."
      },
      "VIEW_RECORDED_MEETINGS": "View my recorded meetings",
      "SITUATIONS": {
        "TITLE": "Situations",
        "DESCRIPTION": "Configure which capabilities to use in certain situations",
        "NO_SITUATIONS_CONFIGURED": "No situations configured",
        "ADD_SITUATION": "Add situation",
        "WHEN": "When",
        "USE": "Use"
      }
    },
    "CONSTRAINTS": {
      "TITLE": "Constraints",
      "VIEWING": {
        "HIDE_FROM_USERS": "Always hide from users",
        "HIDE_FROM_USERS_HINT": "Hidden functions will still show when assigned to visible capabilities."
      },
      "ASSIGNMENT": {
        "TITLE": "Assignment",
        "TOOLTIP_TEXT": "Controls which employees this can be assigned to. If no restrictions are specified, it can be assigned to any employee. If restrictions are added, it will only be available to employees matching the specified namespace types or employee types.",
        "NO_RESTRICTIONS": "No assignment restrictions - can be assigned to any employee",
        "RESTRICT_BY_PLACEHOLDER": "Restrict by",
        "ASSISTANT_TYPE": "Employee Type",
        "NAMESPACE_TYPE": "Namespace Type",
        "SELECT_NAMESPACE_TYPE": "Select namespace type",
        "SELECT_ASSISTANT_TYPE": "Select employee type",
        "SELECT_RESTRICTION_FIRST": "Select restriction type first",
        "ADD_RESTRICTION": "+ Add employee restriction"
      },
      "INVOKE": {
        "TITLE": "Invoke Constraints",
        "TOOLTIP_TEXT": "Controls which channels and contexts this can be invoked from. If no constraints are specified, it can be invoked from any context.",
        "NO_CONSTRAINTS": "No invoke constraints - can be invoked from any context",
        "MEDIUM_PLACEHOLDER": "Medium",
        "CHANNEL_PLACEHOLDER": "Channel",
        "AUTH_STATE_PLACEHOLDER": "Auth State",
        "APP_PLACEHOLDER": "App",
        "ANY": "Any",
        "ANY_CHANNEL": "Any channel",
        "ADD_CONSTRAINT": "+ Add invoke constraint"
      },
      "FORM_NOT_AVAILABLE": "Constraints form not available"
    },
    "MCP": {
      "IMPORT": "Import MCP Tools",
      "FIND_TOOLS": "Find tools",
      "NAME": "MCP Name",
      "URL": "MCP URL",
      "ALREADY_EXISTS": "This MCP already exists. Are you sure you want to update it?",
      "CONFIRMATION_TITLE": "Confirm MCP Update",
      "UPDATE_MCP": "Update MCP",
      "TOOLS_SAVED": "Tools saved",
      "NAME_PATTERN_ERROR": "Name must be under 32 characters and can only include letters, numbers, underscores, or dashes.",
      "PREFIX_TOOLS": "Prefix imported tools with MCP name"
    },
    "ASSISTANT_REFERENCE_CARD": {
      "SELECT_ASSISTANT": "Select employee"
    },
    "TESTING": {
      "PAGE_TITLE": "AI Testing",
      "SELECT_ASSISTANT": "Select an Assistant",
      "NO_ASSISTANTS_FOUND": "No assistants found",
      "TESTING_SUFFIX": "Testing",
      "UPLOAD_JSON": "Upload JSON",
      "UPLOAD_TEST_CASES": "Upload Test Cases",
      "GENERATE_TEST_CASES": "Generate Test Cases",
      "DOWNLOAD_TEMPLATE": "Download Template",
      "CONFIGURE_TEST_RUN": "Configure Test Run",
      "VIEW_TEST_RUN": "View Test Run",
      "ERROR_UPLOADING": "An error occurred while uploading the test cases.",
      "TESTS_SAVED": "Tests Saved",
      "SELECT_MODEL_CONFIG": "Please select at least one model configuration",
      "STARTED_TEST_RUNS": "Started {{count}} test run(s)",
      "ERROR_RUNNING_TESTS": "An error occurred while attempting to run tests",
      "DEFAULT_TEST_RUN_NAME": "Test Run",
      "DEFAULT_VOICE_TEST_RUN_NAME": "Voice Test Run",
      "JOBS_TO_BE_DONE": {
        "EMPTY": "No conversations have been evaluated for your AI employee yet.",
        "LOAD_ERROR": "Something went wrong. Please try refreshing the page.",
        "SCENARIO_LABEL": "When a conversation is considered",
        "EXPECTATION_LABEL": "How a conversation is evaluated",
        "CONVERSATION_COLUMN": "Conversation",
        "RESULT_COLUMN": "Result",
        "RESULTS_EMPTY": "No conversations have been scored for this job yet.",
        "RESULTS_LOAD_ERROR": "Something went wrong loading these conversations. Please try again.",
        "LOAD_MORE_ERROR": "Couldn't load more conversations. Please try again.",
        "LOADING": "Loading conversations",
        "ADD_BUTTON": "Add job",
        "NOT_EVALUATED": "Not evaluated yet",
        "CUSTOM_BADGE": "Custom",
        "CREATE_MODAL": {
          "TITLE": "Add a job to be done",
          "EDIT_TITLE": "Edit job",
          "INTRO": "Describe a job you expect your AI employee to do, and how you'd know it did it well.",
          "NAME_LABEL": "Name",
          "NAME_PLACEHOLDER": "Books an appointment",
          "NAME_REQUIRED": "Give this job a name",
          "SCENARIO_LABEL": "When a conversation is considered",
          "SCENARIO_HINT": "Only conversations that match are scored against this job.",
          "SCENARIO_PLACEHOLDER": "The customer asks to book a service",
          "SCENARIO_REQUIRED": "Describe when this job applies",
          "SCENARIO_TOO_LONG": "Keep this to {{ max }} characters or fewer",
          "EXPECTATION_LABEL": "How a conversation is evaluated",
          "EXPECTATION_HINT": "What has to happen for the conversation to pass.",
          "EXPECTATION_PLACEHOLDER": "The AI employee confirms a date and time, and repeats it back to the customer",
          "EXPECTATION_REQUIRED": "Describe what a good conversation looks like",
          "SUBMIT": "Add job"
        }
      },
      "TEST_CASES": {
        "TITLE": "Test Cases",
        "ACTIONS": "Actions",
        "RUN_SELECTED": "Run Selected Tests",
        "NAME": "Name",
        "PROMPT": "Prompt",
        "MULTIPLE": "Multiple",
        "EXPECTATION": "Expectation",
        "AGENT_ARCHITECTURE": "Agent Architecture",
        "CREATE": "Create Test Case",
        "SAVED": "Test case saved",
        "ERROR_SAVING": "An error occurred while saving the test case.",
        "DELETE_TITLE": "Delete Test Case",
        "DELETE_CONFIRM": "Are you sure you want to delete this test case?",
        "DELETED": "Test case deleted",
        "ERROR_DELETING": "An error occurred while deleting the test case.",
        "SUCCESS_EVALUATOR_BADGE": "Success Evaluator",
        "FILTER_ONLY_EVALUATORS": "Show success evaluators only",
        "EVALUATE_CONVERSATION": "Evaluate Conversation",
        "EVALUATE_CALL_RECORD": "Evaluate Call Record"
      },
      "EDIT_MODAL": {
        "EDIT_TITLE": "Edit Test Case",
        "CREATE_TITLE": "Create Test Case",
        "COPY_ID_TOOLTIP": "Copy ID",
        "COPY_ID_ARIA_LABEL": "Copy test case ID",
        "TEST_NAME": "Test Name",
        "TEST_NAME_PLACEHOLDER": "Name of the test",
        "TEST_NAME_REQUIRED": "Test name is required",
        "CONVERSATION": "Conversation",
        "ROLE": "Role",
        "ROLE_USER": "User",
        "ROLE_ASSISTANT": "Assistant",
        "CONTENT": "Content",
        "CONTENT_PLACEHOLDER_USER": "Chat message",
        "CONTENT_REQUIRED_USER": "Required: The user's message to the AI",
        "CONTENT_REQUIRED_ASSISTANT": "Required: The AI's response to the user",
        "ADD_CHAT": "+ Add chat",
        "EXPECTATION_LABEL": "Expectation",
        "EXPECTATION_PLACEHOLDER": "Assistant's response should...",
        "EXPECTATION_REQUIRED": "Required: Description of what the AI's response should include",
        "AGENT_ARCHITECTURE": "Agent Architecture",
        "ARCHITECTURE_STANDARD": "Standard",
        "ARCHITECTURE_REACT": "ReAct",
        "ARCHITECTURE_SUPERVISOR": "Supervisor",
        "EXPECTED_CITATIONS": "Citations",
        "ADD_CITATION": "+ Add expected citation",
        "CITATION_TITLE_LABEL": "Title",
        "CITATION_TITLE_PLACEHOLDER": "Knowledge source title (optional)",
        "CITATION_TYPE_LABEL": "Type",
        "CITATION_TYPE_ANY": "Any",
        "CITATION_TYPE_WEBSITE": "Website",
        "CITATION_TYPE_BUSINESS_PROFILE": "Business Profile",
        "CITATION_TYPE_FILE": "File",
        "CITATION_TYPE_USER_INPUT": "Text",
        "CITATION_LINK_LABEL": "Link",
        "CITATION_LINK_PLACEHOLDER": "URL (optional)",
        "TOOL_CALLS": "Tool Calls",
        "REQUIRE_ARGUMENTS": "Require Specific Arguments",
        "REQUIRE_RESPONSE": "Require Specific Response",
        "ADD_TOOL_CALL": "+ Add expected tool call",
        "TOOL_NAME_LABEL": "Name",
        "TOOL_NAME_PLACEHOLDER": "Tool Name",
        "EXPECTED_ARGUMENTS": "Expected Arguments JSON",
        "EXPECTED_RESPONSE": "Expected Response",
        "CALLER_INSTRUCTIONS": "Caller Instructions",
        "CALLER_INSTRUCTIONS_PLACEHOLDER": "Describe how the caller should behave...",
        "CALLER_INSTRUCTIONS_REQUIRED": "Caller instructions are required for voice tests",
        "SUCCESS_EVALUATOR_TOGGLE": "Success Evaluator",
        "SCENARIO_LABEL": "Scenario",
        "SCENARIO_PLACEHOLDER": "e.g. user asks about business hours",
        "SCENARIO_REQUIRED": "Add a scenario to use success evaluation",
        "SYNC_HINT_CHAT": "Your scenario and chat history may be out of sync. Double-check they match.",
        "SYNC_HINT_VOICE": "Your scenario and caller instructions may be out of sync. Double-check they match."
      },
      "UPLOAD_MODAL": {
        "TITLE": "Upload Test Cases",
        "TITLE_CHAT": "Upload Chat Test Cases",
        "TITLE_VOICE": "Upload Voice Test Cases",
        "CASES_FOUND": "{{count}} test cases found",
        "ERRORS_FOUND": "{{count}} errors found",
        "ERROR_IN_CASE": "Error in test case {{index}}",
        "REPLACE_EXISTING": "Replace existing test cases",
        "NAME_REQUIRED": "Test case name is required.",
        "HISTORY_EMPTY": "Chat history cannot be empty.",
        "CONTENT_REQUIRED": "Chat message content is required.",
        "ROLE_INVALID": "Chat message role must be either \"user\" or \"assistant\".",
        "EXPECTATION_REQUIRED": "Expectation is required.",
        "CALLER_INSTRUCTIONS_REQUIRED": "Caller instructions are required.",
        "INVALID_JSON": "File is not valid JSON."
      },
      "RUN_OPTIONS": {
        "TITLE": "Run Options",
        "DESCRIPTION": "Select one or more models to run your tests against.",
        "ACTIVE": "Active",
        "ACTIVE_TOOLTIP": "This is the model currently configured on the assistant",
        "REASONING": "Reasoning:",
        "SELECT_MODEL_WARNING": "Please select at least one model to run tests.",
        "ITERATIONS_LABEL": "Iterations per test",
        "ITERATIONS_HINT": "Run each test 1-25 times to measure consistency",
        "RUN_TESTS": "Run Tests",
        "CONFIG": "config",
        "CONFIGS": "configs",
        "VOICE_CONFIGS_DESCRIPTION": "Select one or more voice configurations to run your tests against.",
        "VOICE_CONFIG": "Voice config",
        "VOICE_CONFIG_N": "Voice config {{n}}",
        "ADD_VOICE_CONFIG": "Add voice config",
        "REMOVE_VOICE_CONFIG": "Remove voice config",
        "USE_ASSISTANT_SETTINGS": "Use active setting",
        "OVERRIDE": "Override",
        "RUN_NAME_FALLBACK": "Test",
        "ACTIVE_VOICE_SUFFIX": "Default",
        "VOICE_FAMILY_FALLBACK": "Voice",
        "ASSISTANT_VERSION_TITLE": "Employee Version",
        "ASSISTANT_VERSION_DESCRIPTION": "Choose which version of the employee's configuration these tests run against.",
        "ASSISTANT_VERSION_LABEL": "Version",
        "VERSION_CURRENT": "Current configuration",
        "VERSION_CURRENT_NUMBERED": "Version {{number}} (Current)",
        "VERSION_LOAD_ERROR": "We couldn't load the version history. Tests will run against the current configuration.",
        "DRAFT_CHECK_ERROR": "We couldn't check for unpublished changes, so they aren't available to select.",
        "VERSION_VOICE_LOAD_ERROR": "This version's voice settings aren't available. Entries set to use the assistant's settings will run the current voice."
      },
      "RUN_TABLE": {
        "TITLE": "Test Run History",
        "FILTER_ONLY_SUCCESS_EVALUATIONS": "Show success evaluations only",
        "SOURCE_FILTER_KIND": "Filter by",
        "SOURCE_TYPE_CONVERSATION": "Conversation ID",
        "SOURCE_TYPE_CALL": "Call record ID",
        "SOURCE_ID_LABEL": "Source ID",
        "SOURCE_ID_PLACEHOLDER_CONVERSATION": "Search by conversation ID...",
        "SOURCE_ID_PLACEHOLDER_CALL": "Search by call record ID...",
        "COMPARE_SELECTED": "Compare Selected",
        "SELECT_COMPARE": "Select 2 test runs to compare results ({{count}}/2 selected)",
        "NAME": "Name",
        "DATE": "Date",
        "TRIGGER": "Trigger",
        "TRIGGER_MANUAL": "Manual",
        "TRIGGER_SCHEDULED": "Scheduled",
        "STATUS": "Status",
        "PASS_RATE": "Pass Rate",
        "ITERATIONS": "Iterations",
        "AVG_LATENCY": "Avg Latency",
        "MODEL_REASONING": "Model (Reasoning Effort)",
        "VERSION": "Version",
        "NA": "N/A"
      },
      "RUN_DISPLAY": {
        "TEST_RUN_SUFFIX": "Test Run",
        "NO_MATCHING_CASES_TITLE": "No matching evaluator cases",
        "NO_MATCHING_CASES": "No success evaluator cases matched this conversation.",
        "SUCCESS_EVALUATION_BADGE": "Success Evaluation",
        "SOURCE_CONVERSATION_LABEL": "Source conversation",
        "SOURCE_CALL_RECORD_LABEL": "Source call",
        "VIEW_WORKFLOW": "View Workflow",
        "TEST_RESULTS": "Test Results -",
        "TESTS_PASSED": "Tests Passed",
        "CANCEL_RUN": "Cancel Run",
        "RETRY_STUCK": "Retry Stuck Run",
        "RETRY_TOOLTIP": "Use this if the test run has been stuck in progress longer than expected",
        "LATENCY_TOOLTIP": "Time it took for the AI to generate a response",
        "RETRYING": "Retrying stuck test cases. Results will update shortly.",
        "STILL_RUNNING": "Tests are still running. Please try again in a few minutes.",
        "RETRY_ERROR": "Unable to retry. Please try again later.",
        "TEST_SUITE_PREFIX": "Test Suite:",
        "SCORE": "Score",
        "MODEL": "Model",
        "LATENCY": "Latency"
      },
      "RUN_COMPARISON": {
        "TITLE": "Compare Test Runs",
        "RUN_A": "Run A",
        "RUN_B": "Run B",
        "SUMMARY": "Comparison Summary",
        "COMPARED": "Compared",
        "IMPROVED": "Improved",
        "REGRESSED": "Regressed",
        "UNCHANGED": "Unchanged",
        "UNMATCHED": "Unmatched",
        "TEST_CASE_COMPARISON": "Test Case Comparison",
        "NOT_IN_RUN_A": "Not present in Run A",
        "NOT_IN_RUN_B": "Not present in Run B",
        "UNMATCHED_TESTS": "Unmatched Tests",
        "ONLY_IN_RUN_A": "Only in Run A",
        "ONLY_IN_RUN_B": "Only in Run B",
        "SCORE": "Score:",
        "STATUS": "Status:",
        "MODEL": "Model:",
        "LATENCY": "Latency:",
        "CHAT_HISTORY": "Chat History:",
        "EXPECTATION": "Expectation:",
        "EVALUATION": "Evaluation:",
        "REASONING_LABEL": "Reasoning:",
        "TOOLS_CALLED": "Tools Called:",
        "VIEW_FILE": "View File",
        "SOURCES": "Sources",
        "STREAMING_CHUNKS": "Streaming Chunks",
        "ERROR": "Error",
        "SEQUENCE": "Sequence:"
      },
      "RUN_CONFIGURATION": {
        "TITLE": "Test Run Configuration",
        "SELECT_MODELS": "Select Models to Test",
        "SELECT_MODELS_DESC": "Select one or more models to run your tests against. Each model/reasoning combination will create a separate test run.",
        "ACTIVE": "Active",
        "ACTIVE_TOOLTIP": "This is the model currently configured on the assistant",
        "REASONING": "Reasoning:",
        "SELECT_WARNING": "Please select at least one model to run tests.",
        "ITERATIONS_TITLE": "Test Iterations",
        "ITERATIONS_DESC": "Run each test multiple times to measure consistency across runs.",
        "ITERATIONS_LABEL": "Iterations per test",
        "ITERATIONS_HINT": "Run each test 1-25 times",
        "RUNS_TO_CREATE": "Test Runs to Create",
        "RUNS_DESC": "Review and customize the names for each test run. Click the edit button to change a name.",
        "RUNNING": "Running...",
        "RUN_TESTS_WITH": "Run Tests With",
        "CONFIGURATION": "Configuration",
        "CONFIGURATIONS": "Configurations",
        "NO_CONTEXT": "No assistant or test suite configured",
        "STARTED_RUNS": "Started {{count}} test run(s)",
        "FAILED_START": "Failed to start test runs"
      },
      "RESULTS_MODAL": {
        "REASONING": "Reasoning",
        "REASONING_SUCCESS_EVAL": "Why This Matched the Scenario",
        "SOURCES": "Sources",
        "VIEW_FILE": "View File",
        "EXPECTATION": "Expectation",
        "EVALUATION": "Evaluation",
        "STREAMING_CHUNKS": "Streaming Chunks",
        "ERROR": "Error",
        "SEQUENCE": "Sequence:",
        "EXPECTED_CITATIONS": "Expected Citations",
        "EXPECTED_TOOL_CALLS": "Expected Tool Calls",
        "TOOLS_CALLED": "Tools Called",
        "NO_TOOLS_CALLED": "No tools were called during this test.",
        "CALLER_INSTRUCTIONS": "Caller Instructions",
        "VOICE_CONFIG": "Voice",
        "RECORDING": "Recording",
        "RECORDING_UNAVAILABLE": "Recording not available",
        "CALL_DURATION": "Call Duration",
        "TRANSCRIPT": "Transcript",
        "SCENARIO_LABEL": "Scenario",
        "VERSION": "Version"
      },
      "EVALUATE_MODAL": {
        "TITLE_CONVERSATION": "Evaluate Conversation",
        "TITLE_CALL": "Evaluate Call Record",
        "CONVERSATION_ID_LABEL": "Conversation ID",
        "CONVERSATION_ID_PLACEHOLDER": "Paste a conversation ID",
        "CALL_RECORD_ID_LABEL": "Call Record ID",
        "CALL_RECORD_ID_PLACEHOLDER": "Paste a call record ID",
        "ID_REQUIRED": "ID is required",
        "RUN": "Run Evaluation",
        "STARTED": "Success evaluation started",
        "ERROR": "An error occurred while starting the success evaluation."
      },
      "TOOL_CALL_MODAL": {
        "CLOSE": "Close",
        "ARGUMENTS": "Arguments",
        "RESPONSE": "Response",
        "COPY": "Copy"
      },
      "GENERATE": {
        "TITLE": "Generate Test Cases",
        "TITLE_CHAT": "Generate Chat Test Cases",
        "TITLE_VOICE": "Generate Voice Test Cases",
        "INSTRUCTIONS_LABEL": "Additional Instructions",
        "INSTRUCTIONS_PLACEHOLDER": "Provide any additional instructions for test case generation...",
        "INSTRUCTIONS_HINT": "Generated test cases are based on the assistant's configured prompt. You can optionally describe what kinds of test cases you want generated, or any specific scenarios to cover, etc.",
        "GENERATE": "Generate",
        "NO_CASES": "No test cases generated",
        "NO_CASES_HINT": "Try adjusting your instructions and generating again.",
        "TRY_AGAIN": "Try Again",
        "GENERATED_CASES": "Generated Test Cases",
        "MESSAGES": "messages",
        "SAVE_ALL": "Save All",
        "SAVED": "Test cases saved",
        "ERROR_GENERATING": "Failed to generate test cases.",
        "ERROR_SAVING": "Failed to save test cases."
      },
      "SELECTOR_MODAL": {
        "TITLE_CHAT": "Add Chat Test Cases to Suite",
        "TITLE_VOICE": "Add Voice Test Cases to Suite",
        "SELECT_NAMESPACE": "1. Select Namespace",
        "SELECT_ASSISTANT": "2. Select Assistant",
        "NO_ASSISTANTS": "No assistants found in this namespace",
        "SELECT_CASES": "3. Select Test Cases",
        "NO_CHAT_CASES": "No available chat test cases found (they may already be in the suite)",
        "NO_VOICE_CASES": "No available voice test cases found (they may already be in the suite)",
        "SELECT_ALL": "Select All",
        "AVAILABLE": "available",
        "ADD_CASES": "Add {{count}} Test Case(s)"
      },
      "SUITE": {
        "TITLE": "Test Suite",
        "EDIT": "Edit",
        "TEST_CASES": "Test Cases",
        "ADD_TEST_CASES": "Add Test Cases",
        "NO_CASES": "No test cases in this suite yet.",
        "NO_CASES_HINT": "Add test cases from your assistants to build a comprehensive test suite.",
        "REMOVE_FROM_SUITE": "Remove from Suite",
        "UPDATED": "Test suite updated successfully",
        "UPDATE_ERROR": "Failed to update test suite",
        "ADDED_CASES": "Added {{count}} test case(s) to suite",
        "ADD_ERROR": "Failed to add test cases",
        "REMOVED": "Test case removed from suite",
        "REMOVE_ERROR": "Failed to remove test case",
        "DELETE_TITLE": "Delete Test Suite",
        "DELETE_CONFIRM": "Are you sure you want to delete this test suite? This cannot be undone.",
        "DELETED": "Test suite deleted",
        "DELETE_ERROR": "Failed to delete test suite",
        "LOAD_ERROR": "Failed to load test suite",
        "RUN_CHAT_TESTS": "Run Chat Tests",
        "RUN_VOICE_TESTS": "Run Voice Tests"
      },
      "SCHEDULE_CARD": {
        "TITLE": "Schedule & Notifications",
        "TIER_LABEL": "Schedule",
        "TIER_HINT": "How often this suite automatically runs all of its test cases.",
        "TIER_OFF_HINT": "Schedule is off. Select Daily or Weekly to activate.",
        "TIER_NONE": "None",
        "TIER_DAILY": "Daily",
        "TIER_WEEKLY": "Weekly",
        "WEBHOOK_LABEL": "Google Chat webhook URL",
        "WEBHOOK_HINT": "Incoming webhook URL for the Google Chat space that should receive failure notifications from scheduled runs.",
        "WEBHOOK_TOO_LONG": "Webhook URL is too long",
        "WEBHOOK_INVALID": "Must be a Google Chat webhook URL (https://chat.googleapis.com/...)",
        "SHOW_WEBHOOK": "Show webhook URL",
        "HIDE_WEBHOOK": "Hide webhook URL",
        "CONSECUTIVE_LABEL": "Consecutive failure threshold",
        "CONSECUTIVE_HINT": "Notify when a single test case fails this many scheduled runs in a row. 0 turns this alert off.",
        "PERCENTAGE_LABEL": "Failure threshold percentage",
        "PERCENTAGE_HINT": "Send a notification when the share of failing test cases in a run reaches this percentage.",
        "THRESHOLD_RANGE_ERROR": "Enter a whole number between 0 and 100",
        "SAVED": "Schedule settings saved"
      },
      "SUITE_MODAL": {
        "NAME_LABEL": "Suite Name",
        "NAME_PLACEHOLDER": "Enter test suite name",
        "NAME_REQUIRED": "Name is required",
        "EDIT_TITLE": "Edit Test Suite",
        "CREATE_TITLE": "Create Test Suite",
        "CREATE": "Create"
      },
      "STATUS": {
        "INITIALIZING": "Initializing",
        "IN_PROGRESS": "In progress",
        "SUCCESS": "Success",
        "FAILURE": "Failure"
      },
      "ARCHITECTURE": {
        "REACT": "ReAct",
        "SUPERVISOR": "Supervisor",
        "STANDARD": "Standard",
        "DEEP_RESEARCH": "Deep Research",
        "UNSET": "Unset"
      },
      "TEST_TYPE": {
        "CHAT": "Chat",
        "VOICE": "Voice"
      },
      "CONTEXT": {
        "SECTION_LABEL": "Invocation context",
        "CHANNEL_LABEL": "Channel",
        "AUTH_STATE_LABEL": "Auth state",
        "APP_LABEL": "App",
        "MEDIUM_LABEL": "Medium",
        "MEDIUM": {
          "TEXT": "Text",
          "VOICE": "Voice"
        },
        "CHANNEL": {
          "WEBCHAT": "Webchat",
          "SMS": "SMS",
          "WHATSAPP": "WhatsApp",
          "FACEBOOK": "Facebook",
          "INSTAGRAM": "Instagram",
          "EMAIL": "Email",
          "PLATFORM": "Platform",
          "SNAPSHOT": "Snapshot",
          "SYSTEM": "System",
          "PHONE": "Phone"
        },
        "AUTH_STATE": {
          "UNSET": "Unspecified",
          "ANONYMOUS": "Anonymous",
          "AUTHENTICATED": "Authenticated"
        },
        "APP": {
          "UNSET": "Unspecified",
          "BUSINESS_CENTER": "Business Center",
          "PARTNER_CENTER": "Partner Center"
        }
      },
      "ROLES": {
        "ASSISTANT": "Assistant",
        "USER": "User",
        "CALLER": "Caller"
      },
      "CONTENT_TYPE": {
        "REASONING": "Reasoning",
        "ANSWER": "Answer",
        "ACTION_DESCRIPTION": "Action Description",
        "WORKING": "Working",
        "UNSPECIFIED": "Unspecified"
      },
      "DEFAULT_MODEL": "Default"
    },
    "PROPOSED_ACTION": {
      "YES": "Yes",
      "NO": "No",
      "CHANGE_SOMETHING": "Change something",
      "APPROVED": "approved",
      "DECLINED": "declined",
      "FETCH_ERROR": "Failed to fetch proposed action"
    },
    "SUMMARY": {
      "TITLE": "Employee",
      "AUTONOMY": "Autonomy",
      "NO_DESCRIPTION": "No description yet.",
      "EMPLOYEE_NOT_FOUND": "Employee not found",
      "ERROR_FETCHING_EMPLOYEE": "It may not exist, or you may not have access to it.",
      "SETTINGS_SAVED": "Settings saved",
      "SETTINGS_SAVE_ERROR": "Some settings could not be saved. Try again."
    }
  }
}
